import { db as firestore } from '../firebase';
import { doc, setDoc, deleteDoc } from 'firebase/firestore';
import dexie from '../offlineDB';

export async function flushPendingWrites(user) {
  if (!user?.uid) {
    console.warn('[flushPendingWrites] No valid user — skipping');
    return;
  }

  const writes = await dexie.pendingWrites.toArray();

  for (const write of writes) {
  const { id, type, collection, docId, data } = write;

  const fallbackCollection = {
    tune: 'tunes',
    set: 'sets',
    session: 'sessions',
    preference: 'preferences'
  }[type];

  const finalCollection = collection || fallbackCollection || 'tunes';
  if (!finalCollection || !docId) {
    console.warn('⚠️ Skipping malformed pending write:', write);
    await dexie.pendingWrites.delete(id);
    continue;
  }

  const ref = doc(firestore, 'users', user.uid, finalCollection, docId);

  try {
    if (type === 'add' || type === 'update') {
      await setDoc(ref, data, { merge: type === 'update' });

      // 💾 Update local Dexie cache
      if (finalCollection === 'tunes') {
        await dexie.tunes.put({ id: docId, ...data });
      } else if (finalCollection === 'sets') {
        await dexie.sets.put({ id: docId, ...data });
      } else if (finalCollection === 'sessions') {
        await dexie.sessions.put({ id: docId, ...data });
      } else if (finalCollection === 'preferences') {
        await dexie.preferences.put({ id: docId, ...data });
      }
    } else if (type === 'delete') {
      await deleteDoc(ref);

      if (finalCollection === 'tunes') {
        await dexie.tunes.delete(docId);
      } else if (finalCollection === 'sets') {
        await dexie.sets.delete(docId);
      } else if (finalCollection === 'sessions') {
        await dexie.sessions.delete(docId);
      } else if (finalCollection === 'preferences') {
        await dexie.preferences.delete(docId);
      }
    }

    await dexie.pendingWrites.delete(id);
    console.log(`✅ Synced ${type} to ${finalCollection}/${docId}`);
  } catch (err) {
    console.warn('❌ Sync failed for', write, err);
    // retry later
  }
}

}

export async function addPendingWrite(write) {
  await dexie.pendingWrites.add(write);
}
